import AppConstants from '../constants/AppConstants';

export const initialState = {
    last: {
        data: [],
        parameters: {},
        loading: false
    },
    today: {
        data: [],
        parameters: {},
        loading: false
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.DASHBOARD_LAST_START_LOADING:
            return {
                ...state,
                last: {
                    ...state.last,
                    loading: true
                }
            };

        case AppConstants.DASHBOARD_LAST_SUCCESS:
            return {
                ...state,
                last: {
                    parameters: action.items.parameters,
                    data: _addTotals(action.items.rows, action.items.totals),
                    loading: false
                }
            };

        case AppConstants.DASHBOARD_TODAY_START_LOADING:
            return {
                ...state,
                today: {
                    ...state.last,
                    loading: true
                }
            };

        case AppConstants.DASHBOARD_TODAY_SUCCESS:
            return {
                ...state,
                today: {
                    parameters: action.items.parameters,
                    data: action.items.rows,
                    loading: false
                }
            };

        case AppConstants.DASHBOARD_CLEAR:
            return {
                ...state,
                ...initialState
            };

        default:
            return state;
    }
};

const _addTotals = (list, totals) => {
    if (!list.length) {
        return list;
    }

    let newList = [
        ...list,
        totals
    ];

    return newList;
};
